import { motion } from 'framer-motion';

export default function GlowingCard({ children, className = '' }) {
  return (
    <motion.div
      className={`glass-card relative overflow-hidden ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.01 }}
    >
      {/* Corner decorations */}
      <div className="absolute top-3 left-3 w-2 h-2 border-t-2 border-l-2 border-robo-green/50 rounded-tl" />
      <div className="absolute top-3 right-3 w-2 h-2 border-t-2 border-r-2 border-robo-green/50 rounded-tr" />
      <div className="absolute bottom-3 left-3 w-2 h-2 border-b-2 border-l-2 border-robo-green/50 rounded-bl" />
      <div className="absolute bottom-3 right-3 w-2 h-2 border-b-2 border-r-2 border-robo-green/50 rounded-br" />
      
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
}